import styled from "styled-components";

export const StyledChat = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
`;

export const StyledChatContent = styled.div`
    padding: 40px;
    height: 100%;
`;